import React from 'react'
import PhoneInputJS from './PhoneInputJS'

interface IPhoneInputProp {
  defaultValue?: string
  isRequired?: boolean
  invalidMessage?: string
  onChange: (value: string) => void
  onEntered?: (value: string) => void
  style?: object
}

const PhoneInput: React.FC<IPhoneInputProp> = ({
  defaultValue,
  isRequired,
  invalidMessage,
  onChange,
  onEntered,
  style,
}: IPhoneInputProp) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...style }}>
      <PhoneInputJS
        defaultValue={defaultValue}
        isRequired={isRequired}
        invalidMessage={invalidMessage}
        onChange={onChange}
        onEntered={onEntered}
        style={style}
      />
    </div>
  )
}
export default PhoneInput
